import * as actions from './actions';
import * as mutations from './mutations';

const state = {
  items: [],
  isLoading: false
};

export default {
  actions,
  mutations,
  namespaced: true,
  state
};
